module.exports = __webpack_public_path__ + "img/emoji_18.c2bbcfa9.png";